var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2cb89e04bc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.203125 5.203125 L 369.796875 5.203125 L 369.796875 369.796875 L 5.203125 369.796875 Z M 5.203125 5.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3291fa23b6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 5.203125 C 86.820312 5.203125 5.203125 86.820312 5.203125 187.5 C 5.203125 288.179688 86.820312 369.796875 187.5 369.796875 C 288.179688 369.796875 369.796875 288.179688 369.796875 187.5 C 369.796875 86.820312 288.179688 5.203125 187.5 5.203125 Z M 187.5 5.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2983d16a12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.203125 0.203125 L 364.796875 0.203125 L 364.796875 364.796875 L 0.203125 364.796875 Z M 0.203125 0.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0ead547abb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 182.5 0.203125 C 81.820312 0.203125 0.203125 81.820312 0.203125 182.5 C 0.203125 283.179688 81.820312 364.796875 182.5 364.796875 C 283.179688 364.796875 364.796875 283.179688 364.796875 182.5 C 364.796875 81.820312 283.179688 0.203125 182.5 0.203125 Z M 182.5 0.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2fa18575f4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 365,
    y: 0,
    height: 365
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0170c1e5b6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 89.925781 96.613281 L 279.675781 96.613281 L 279.675781 283.363281 L 89.925781 283.363281 Z M 89.925781 96.613281 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2cb89e04bc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3291fa23b6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 5, 5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2fa18575f4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2983d16a12)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0ead547abb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M 0.203125 0.203125 L 364.796875 0.203125 L 364.796875 364.796875 L 0.203125 364.796875 Z M 0.203125 0.203125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0170c1e5b6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 184.800781 283.484375 C 181.164062 283.484375 177.558594 282.125 174.710938 279.433594 L 155.167969 260.703125 L 131.195312 260.703125 C 108.457031 260.703125 89.957031 242.195312 89.957031 219.445312 L 89.957031 137.90625 C 89.925781 115.15625 108.425781 96.648438 131.164062 96.648438 L 238.40625 96.648438 C 261.144531 96.648438 279.644531 115.15625 279.644531 137.90625 L 279.644531 219.382812 C 279.644531 242.128906 261.144531 260.640625 238.40625 260.640625 L 214.402344 260.640625 L 194.859375 279.371094 C 192.042969 282.09375 188.40625 283.421875 184.769531 283.421875 Z M 131.164062 112.46875 C 117.125 112.46875 105.738281 123.890625 105.738281 137.90625 L 105.738281 219.382812 C 105.738281 233.429688 117.15625 244.820312 131.164062 244.820312 L 155.644531 244.820312 C 159.40625 244.820312 163.011719 246.242188 165.730469 248.871094 L 184.769531 267.125 L 203.808594 248.871094 C 206.527344 246.242188 210.132812 244.820312 213.894531 244.820312 L 238.375 244.820312 C 252.414062 244.820312 263.800781 233.398438 263.800781 219.382812 L 263.800781 137.90625 C 263.800781 123.859375 252.382812 112.46875 238.375 112.46875 Z M 195.871094 150.878906 C 196.628906 134.871094 172.972656 134.871094 173.730469 150.878906 C 173.730469 150.878906 177.558594 192.835938 177.558594 192.835938 C 178.445312 201.535156 191.125 201.597656 192.074219 192.835938 L 195.902344 150.878906 Z M 195.773438 218.242188 C 195.773438 212.167969 190.871094 207.261719 184.800781 207.261719 C 178.730469 207.261719 173.828125 212.167969 173.828125 218.242188 C 173.828125 224.316406 178.730469 229.222656 184.800781 229.222656 C 190.871094 229.222656 195.773438 224.316406 195.773438 218.242188 Z M 195.773438 218.242188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.b716c75b0abd5bd7d1398d8f3ae96bca.svg";
export { ForwardRef as ReactComponent };